import { motion } from 'framer-motion';
import { useState } from 'react';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    
    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4sf3v11e6in3mfvkevg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', service: '', message: '' });
        setTimeout(() => setStatus('idle'), 5000);
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const contactInfo = [
    {
      icon: 'ri-instagram-line',
      title: 'Instagram',
      items: ['@nexuflowdynamics', '@hrcarrasquel'],
      color: 'pink'
    },
    {
      icon: 'ri-telegram-line',
      title: 'Telegram',
      items: ['QuantFin Signals', 'AULA MOTORIZADA'],
      color: 'cyan'
    },
    {
      icon: 'ri-facebook-line',
      title: 'Facebook',
      items: ['Programa Educación Vial'],
      color: 'blue'
    },
    {
      icon: 'ri-tiktok-line',
      title: 'TikTok',
      items: ['@hrcarrasquel'],
      color: 'purple'
    }
  ];

  return (
    <section id="contact" className="relative py-32 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
              Conecta con NEXUS
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Comienza tu transformación digital hoy mismo
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <form onSubmit={handleSubmit} data-readdy-form id="contact-form" className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2">
                  Nombre Completo
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-gray-900/50 border border-gray-800 text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors text-sm"
                  placeholder="Tu nombre"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-gray-900/50 border border-gray-800 text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors text-sm"
                  placeholder="tu@email.com"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-2">
                  Teléfono
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-gray-900/50 border border-gray-800 text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors text-sm"
                  placeholder="+1 234 567 8900"
                />
              </div>

              <div>
                <label htmlFor="service" className="block text-sm font-medium text-gray-300 mb-2">
                  Servicio de Interés
                </label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-gray-900/50 border border-gray-800 text-white focus:outline-none focus:border-cyan-500 transition-colors text-sm"
                >
                  <option value="">Selecciona un servicio</option>
                  <option value="agentes-ia">Agentes IA Interactivos 3D</option>
                  <option value="desarrollo-web">Desarrollo Web/Apps Futuristas</option>
                  <option value="educacion">Nexo Educación Inmersiva</option>
                  <option value="paquete-inicio">Paquete Inicio</option>
                  <option value="paquete-pro">Paquete Pro</option>
                  <option value="paquete-quantum">Paquete Quantum</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2">
                  Mensaje
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 rounded-xl bg-gray-900/50 border border-gray-800 text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors resize-none text-sm"
                  placeholder="Cuéntanos sobre tu proyecto..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
              </div>

              <button
                type="submit"
                disabled={status === 'loading'}
                className="w-full py-4 rounded-full bg-gradient-to-r from-cyan-500 to-purple-600 text-white font-semibold hover:shadow-2xl hover:shadow-cyan-500/50 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {status === 'loading' ? 'Enviando...' : 'Enviar Mensaje'}
              </button>

              {status === 'success' && (
                <div className="p-4 rounded-xl bg-green-500/10 border border-green-500/30 text-green-400 text-sm">
                  ¡Mensaje enviado con éxito! Te contactaremos pronto.
                </div>
              )}

              {status === 'error' && (
                <div className="p-4 rounded-xl bg-red-500/10 border border-red-500/30 text-red-400 text-sm">
                  Error al enviar el mensaje. Por favor, intenta de nuevo.
                </div>
              )}
            </form>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div className="p-8 rounded-3xl bg-gradient-to-br from-gray-900/50 to-gray-800/50 border border-gray-800">
              <h3 className="text-2xl font-bold text-white mb-6">Síguenos en Redes</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {contactInfo.map((info) => (
                  <div key={info.title} className="group">
                    <div className={`w-12 h-12 rounded-xl bg-gradient-to-br from-${info.color}-400/20 to-${info.color}-600/20 border border-${info.color}-500/30 flex items-center justify-center mb-3 transform group-hover:scale-110 transition-transform duration-300`}>
                      <i className={`${info.icon} text-2xl text-${info.color}-400`}></i>
                    </div>
                    <h4 className="text-white font-semibold mb-2">{info.title}</h4>
                    {info.items.map((item) => (
                      <p key={item} className="text-gray-400 text-sm">{item}</p>
                    ))}
                  </div>
                ))}
              </div>
            </div>

            <div className="p-8 rounded-3xl bg-gradient-to-br from-cyan-500/10 to-purple-500/10 border border-cyan-500/30">
              <h3 className="text-xl font-bold text-white mb-4">¿Por qué elegir NEXUS?</h3>
              <ul className="space-y-3">
                {[
                  'Tecnología 3D de vanguardia',
                  'Experiencias inmersivas únicas',
                  'Integración completa de IA',
                  'Soporte dedicado 24/7',
                  'Resultados medibles'
                ].map((item) => (
                  <li key={item} className="flex items-center text-gray-300">
                    <i className="ri-check-double-line text-cyan-400 mr-3"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
